import { Skeleton } from '@material-ui/lab';

export const RepresentativesListSkeleton = () => {
  return <Skeleton variant="rect" style={{ width: '100%', height: 151, borderRadius: '8px', marginTop: 20 }} />;
};
